// extracted by mini-css-extract-plugin
export default {"gridButton":"Configuration_gridButton__i7VYq"};